import { create } from 'zustand'
import { FeedbackDialogType } from '../domain'

interface IFeedbackDialogStore {
  type: FeedbackDialogType
  title: string
  open: boolean
  openDialog: (type: FeedbackDialogType, title: string) => void
  closeDialog: () => void
}

export const feedbackDialogStore = create<IFeedbackDialogStore>((set) => ({
  title: '',
  type: 'default',
  open: false,
  openDialog: (type: FeedbackDialogType, title: string) =>
    set(() => ({ type, title, open: true })),
  closeDialog: () => set(() => ({ open: false })),
}))
